import classNames from 'classnames'

import style from './Loader.module.scss'

interface IProps {
    className?: string
}

export const LoaderComponent = (props: IProps) => (
    <div className={classNames(style.container, props.className && props.className)}>
        <div className={style.spinner}></div>
    </div>
)
